import { SearchProps } from '~components/form-fields/search';

export const searchFields: SearchProps = {
  basic_search: {
    persist: true,
    type: 'text-like',
    field: ['first_name', 'surname'],
    placeholder: 'Basic Search',
    caption: 'Basic Search',
  },
};

export default searchFields;
